/**
 * PDP Vestfirma — copiar código do cupom ao clicar.
 */
(function () {
  async function writeClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
    } finally {
      document.body.removeChild(ta);
    }
  }

  document.addEventListener('click', (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-vf-copy-coupon]') : null;
    if (!(btn instanceof HTMLElement)) return;

    const code = (btn.getAttribute('data-coupon-code') || btn.textContent || '').trim();
    if (!code) return;

    writeClipboard(code).then(() => {
      const wrap = btn.closest('.md-pdp__welcome-coupon');
      const feedback = wrap ? wrap.querySelector('[data-vf-copy-feedback]') : null;
      if (!(feedback instanceof HTMLElement)) return;
      feedback.hidden = false;
      window.clearTimeout(btn._vfCopyTimer);
      btn._vfCopyTimer = window.setTimeout(() => {
        feedback.hidden = true;
      }, 2000);
    }).catch(() => {});
  });
})();
